<template>
  <div class="page-container">
    <!-- 顶部tab菜单 -->
    <div class="tab-menu">
      <div v-for="(tab, index) in tabs" :key="index" :class="['tab-item', { active: activeTab === index }]"
        @click="choType(tab, index)">
        {{ tab }}
      </div>
    </div>

    <!-- 内容区域 -->
    <div v-if="newsList1" @click="goNext(`/xxxq?id=${newsList1.id}&uName=新闻资讯&dname=${tab}`)" class="content-section">
      <div class="left-main-news">
        <img :src="newsList1.img" alt="main news" />
        <div class="news-item">
          <div class="news-date">
            <div class="day">{{ formatDate(newsList1.addTime).day }}</div>
            <div class="year">{{ formatDate(newsList1.addTime).year }}.{{ formatDate(newsList1.addTime).month }}
            </div>
          </div>
          <div class="news-content">
            <div class="news-title elp" v-html="newsList1.title"></div>
            <div class="news-intro twoEllipsis">{{ newsList1.introduction }}</div>
          </div>
        </div>
      </div>

      <div class="right-news-list">
        <div  @click="goNext(`/xxxq?id=${item.id}&uName=新闻资讯&dname=${tab}`)" v-for="(item, index) in newsList">
          <div :key="index" class="news-item">
            <div class="item_left">
              <div class="ri"> {{ formatDate(item.addTime).day }}</div>
              <div class="year mt10">
                <div style="margin-right: 5px;" class="yline"></div>

                {{ formatDate(item.addTime).year }}.{{ formatDate(item.addTime).month }}
                <div style="margin-left: 5px;" class="yline"></div>

              </div>
            </div>

            <div class="news-content">
              <div class="news-title elp" v-html="item.title"></div>
              <div class="news-intro twoEllipsis">{{ item.introduction }}</div>
            </div>

          </div>
          <div v-if="index != 2" class="llin">

          </div>
        </div>

      </div>
    </div>
    <div v-else>
      <el-empty description="暂无数据" />
    </div>
  </div>
</template>

<script>
import { queryAllArticle, getEntrantsRelationPcJinGang } from "@/api/home";
export default {
  name: "NewsDynamic",
  data() {
    return {
      tabs: [
        "院校新闻",
        "招生问答",
        "报考指南",
        "校内通知",
        "自考备考",
        "自考政策"
      ],
      activeTab: 0,
      cType: '院校新闻',
      newsList: [],
      newsList1: '',
    };
  },

  created() {
    this.getList()
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      // 补 0 处理月份
      const month = String(date.getMonth() + 1).padStart(2, '0');
      // 补 0 处理日期
      const day = String(date.getDate()).padStart(2, '0');
      return { year, month, day };
    },
    async getList() {

      queryAllArticle("", 3, 1, undefined, this.cType).then((res) => {
        if (res.rows && res.rows.length > 0) {
          this.newsList1 = res.rows[0];
          this.newsList = res.rows.slice(1);
        }else{
          this.newsList1 = '';
          this.newsList = [];
        }

      });


    },
    choType(tab, index) {
      this.cType = tab;
      this.activeTab = index
      this.getList()
    }
  }
};
</script>

<style lang="less" scoped>
.page-container {
  width: 1200px;
  margin: 32px auto 0 auto;
  font-family: "Microsoft YaHei", sans-serif;
  color: #333;
  margin-bottom: 56px;

  .tab-menu {
    display: flex;
    margin-bottom: 20px;

    .tab-item {
      width: 152px;
      height: 55px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      text-align: center;
      line-height: 55px;
      cursor: pointer;
      margin-right: 40px;

      &.active {
        width: 152px;
        height: 55px;
        height: 63px;
        background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x33.png');
        background-size: 100% 100%;
        color: #fff;
      }

      &:hover:not(.active) {
        background: #f0f0f0;
      }
    }
  }

  .content-section {
    display: flex;
    gap: 20px;

    .left-main-news {
      position: relative;
      width: 580px;
      border-radius: 12px;
      cursor: pointer;
      margin-right: 36px;

      img {
        width: 576px;
        height: 308px;
        border-radius: 12px 12px 12px 12px;
        object-fit: cover;
        margin-bottom: 20px;
      }

      .news-item {
        display: flex;
        margin-bottom: 20px;
        cursor: pointer;

        .news-date {
          width: 78px;
          height: 98px;
          background: linear-gradient(180deg, #509FFF 0%, #086AEB 100%);
          border-radius: 4px 4px 4px 4px;
          text-align: center;

          font-family: MiSans, MiSans;
          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
          margin-right: 20px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .day {
            font-size: 36px;
          }

          .year {
            margin-top: 4px;
          }
        }

        .news-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 479px;

          .news-title {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            margin-bottom: 14px;
          }

          .news-intro {
            height: 41px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #78797A;
            line-height: 22px;
          }
        }
      }

    }

    .right-news-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-top: 25px;

      .news-item {
        display: flex;
        margin-bottom: 20px;
        cursor: pointer;

        .item_left {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-right: 24px;

          .ri {

            font-family: MiSans, MiSans;
            font-weight: 500;
            font-size: 44px;
            color: #2080F7;
            text-align: center;
          }

          .year {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: MiSans, MiSans;
            font-weight: 500;
            font-size: 13px;
            color: #5C6471;

            .yline {
              width: 16px;
              height: 1px;
              background: #FFFFFF;
              border-radius: 0px 0px 0px 0px;
              border-bottom: 0.5px solid #5C6471;

              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 13px;
              color: #5C6471;
              position: relative;
              top: 1px
            }
          }
        }

        .news-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          // width: 479px;

          .news-title {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            margin-bottom: 6px;
          }

          .news-intro {
            height: 41px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #78797A;
            line-height: 22px;
          }
        }
        &:hover{
          .news-title{
            color: #0074EF;
          }
        }
      }

    }
  }
}

.llin {
  width: 100%;
  margin: 22px 0;
  height: 0px;
  border-top: 1px dashed  #EEEEEE;
}
</style>
